export default __webpack_public_path__ + "c1945b960ad3baf50abd3860d6cfd7de.jpeg";